import request from './request'

//获取微信签名的接口请求  
export const wxConfigFun = () => {
  let _href = window.location.href.replace('#/', '');
  console.log('url--', _href);
  request({ url: 'jsConfig', data: { url: _href } }).then(result => {
    console.log('签名认证返回数据---', result);
    if (!result.data) return;
    let { appId, timestamp, nonceStr, signature } = result.data;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature,// 必填，签名
      jsApiList: ['wx-open-launch-app'] // 必填，需要使用的JS接口列表
    })
  
    wx.ready(function (res) {
        console.log("JSSDK调用成功-----wx.ready--", res)
    });

    wx.error(function (res) {
        console.log("JSSKD调用错误信息---------", res);
    });

  })
  
}

